export default "__VITE_PUBLIC_ASSET__9b41b400__"